import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { AssessmentSettingsModalComponent } from "@/components/assessment/assessment-settings-modal/assessment-settings-modal.component";
import { ContextualNavService } from "@/_services/contextual-nav.service";
import { AppDialogService } from "@/_services/app-dialog.service";
import { AssessmentDto } from "@/_models";
import { AccountService } from "@/_services/account.service";
import { TabItem } from "@/_models/menu-item";
import { DetailHeaderPrimaryCta } from "@/components/shared/detail-page-header/detail-page-header.model";

@Component({
    selector: "app-create-assessment",
    styleUrls: ["./create-assessment.component.scss"],
    templateUrl: "./create-assessment.component.html",
})
export class CreateAssessmentComponent implements OnInit, OnDestroy {
    navTabs: TabItem[] = [];
    activeTab: "general" | "owned" = "owned";
    readonly headerPrimaryCta: DetailHeaderPrimaryCta = {
        label: "New Report",
    };

    private destroy$ = new Subject<void>();

    constructor(
        private appDialogService: AppDialogService,
        private contextualNavService: ContextualNavService,
        private accountService: AccountService,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.contextualNavService.onAddAction$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => this.createNewAssessmentForm());

        this.route.queryParams
            .pipe(takeUntil(this.destroy$))
            .subscribe((params) => {
                this.activeTab =
                    params["type"] === "general" ? "general" : "owned";
            });

        this.accountService
            .getAccount()
            .pipe(take(1), takeUntil(this.destroy$))
            .subscribe({
                next: (account) => this.buildNavTabs(account?.name),
                error: () => this.buildNavTabs(),
            });
    }

    private buildNavTabs(accountName?: string): void {
        const base = "/assessments/new";
        this.navTabs = [
            {
                label: accountName || "Your Templates",
                link: base,
                query: { type: "owned" },
            },
            { label: "General", link: base, query: { type: "general" } },
        ];
    }

    createNewAssessmentForm() {
        this.appDialogService.open<void, AssessmentDto | null>(
            AssessmentSettingsModalComponent,
            {
                title: "Report Configuration",
                size: "lg",
                data: null,
            },
        );
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
